var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownTrianglePointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 8,
    viewBox: "0 0 17 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70696 7.29289L0.706955 0.292893C0.519419 0.105357 0.265066 0 -0.000151192 0H16.8283C16.5631 0 16.3087 0.105356 16.1212 0.292892L9.12117 7.29289C8.73064 7.68342 8.09748 7.68342 7.70696 7.29289Z",
    fill: "#010B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownTrianglePointer);
export default __webpack_public_path__ + "static/media/DownTrianglePointer.96b464a0bcaab4efff7d1fa266088b0f.svg";
export { ForwardRef as ReactComponent };